import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgServiceConsulting32 = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path d="M13.438 9.031h-1.656v2.563h-2.5v1.5h2.5v2.594h1.656v-2.594h2.531v-1.5h-2.531zm10.968 4.875q.125-.438.188-.875t.063-.875q0-1.844-.922-3.453t-2.547-2.766q-1.625-1.188-3.813-1.875t-4.688-.688q-2.531 0-4.719.688T4.155 5.937Q2.53 7.093 1.608 8.703t-.922 3.453q0 1.813.922 3.422t2.641 2.859v2.344q0 1.219.719 1.875t1.563.656q.406 0 .828-.156t.797-.438l2.313-1.75q.031-.031.188-.078t.406-.047h.109q.046 0 .078.031.344.031.703.047t.734.016q.625 0 1.281-.063t1.313-.156q.031 0 .047-.016t.047-.016q.563 1.844 2.688 3.047t5.094 1.203q.25 0 .516-.016t.516-.047q.781-.031 1.156.172t.375.203l1.813 1.375q.406.281.688.156t.281-.625v-1.969q0-.344.156-.563t.25-.313q1.125-.781 1.766-1.797t.641-2.203q0-2.156-1.922-3.672t-4.984-1.734zM15 19.031q-.563.094-1.141.141t-1.172.047q-.344 0-.672-.016t-.641-.016q-.094-.031-.172-.031t-.141 0q-.844 0-1.234.234t-.391.234l-2.313 1.719q-.156.125-.313.188t-.281.063q-.281 0-.438-.219t-.156-.594v-2.5q-.031-.438-.203-.719t-.328-.375q-1.406-.969-2.219-2.266t-.813-2.766.813-2.766 2.188-2.234q1.406-.969 3.281-1.531t4.031-.563q2.125 0 4 .563t3.25 1.531q1.406.938 2.219 2.234t.813 2.766q0 1.313-.672 2.5t-1.859 2.125q-1.031.844-2.422 1.422t-3.016.828zm11.844 1.375h-5.375V19h5.375z" />
    </SvgIcon>
  );
};
const Memo = memo(SvgServiceConsulting32);
export default Memo;
